import { Button, Col, Form, Input, message, Modal, Row, Select } from "antd";
import { useEffect, useMemo, useState } from "react";
import { ReactComponent as CheckFilled } from "@src/assets/CN/svg/check-filled.svg";
import { ReactComponent as CheckEmpty } from "@src/assets/CN/svg/check-empty.svg";
import { ReactComponent as BlackCall } from "@src/assets/CN/svg/black-call.svg";
import { ReactComponent as CaretDown } from "@src/assets/CN/svg/caret-down-small.svg";
import AddressLinkage from "./AddressLinkage";
import { addUserContactCN } from "@src/Api/CN";
import "./index.less";
import { useTranslation } from "react-i18next";
import CNEnum from "@src/Locales/Constants/CNEnum";
import i18n from "@src/Basic/Language/i18n";
import useContactOpts from "@src/Hooks/CN/useContactOpts";
import {
  FieldCompanyName,
  FieldFirstName,
  FieldAreaCode,
  FieldPhoneNumber,
  FieldEmail,
  FieldCountry,
  FieldContactAddress,
  FieldBusinessType,
  FieldChainStatus,
  FieldOpeningStatus,
  FieldChannelTypeOpts,
  FieldObtainServiceContent,
} from "@src/Components/CNComponents/MobileContactModal/FormItem";

export default function (props: any) {
  const { isOpen, handleIsOpen } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [chainStatus, setChainStatus] = useState<string>("CHAIN");
  const { t } = useTranslation();
  const { chainOptions, businessTypeOptions, AreaCode, businessStatusOpts, understandChannels } =
    useContactOpts();

  const [form] = Form.useForm();

  const handleSubmit = async () => {
    try {
      await form.validateFields();
      const { contactAddress = {}, ...values } = await form.validateFields();
      addUserContactCN({ ...values, ...contactAddress }).then((res) => {
        message.success(t(CNEnum.submitSuccess), 1.5);
        handleIsOpen(false);
      });
    } catch (error) {
      console.log(error);
    }
  };
  const handleCancel = () => {
    handleIsOpen(false);
  };

  useEffect(() => {
    setIsModalOpen(isOpen);
  }, [isOpen]);

  useEffect(() => {
    form.setFieldsValue({
      // 设置表单初始值
      chainStatus: "CHAIN",
      openingStatus: "BUSINESS",
    });
  }, [form]);

  useEffect(() => {
    form.setFieldValue("chainStatus", chainStatus);
  }, [chainStatus]);

  return (
    <Modal className="PCConcatModal" width={640} open={isModalOpen} closeIcon={null} footer={null}>
      <h2 className="title">{t(CNEnum.leaveContactInfo)}</h2>
      <Form form={form} layout="vertical">
        <Row gutter={24}>
          <Col span={12}>
            <FieldCompanyName />
          </Col>
          <Col span={12}>
            <FieldFirstName />
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <div className="flex">
              <FieldAreaCode />
              <FieldPhoneNumber />
            </div>
          </Col>
          <Col span={12}>
            <FieldEmail />
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <FieldCountry />
          </Col>
          <Col span={12}>
            <FieldContactAddress />
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>{FieldBusinessType(businessTypeOptions)}</Col>
          <Col span={12}>{FieldChainStatus(chainOptions)}</Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>{FieldOpeningStatus(businessStatusOpts)}</Col>
          <Col span={12}>{FieldChannelTypeOpts(understandChannels)}</Col>
        </Row>
        <Row gutter={24}>
          <Col span={24}>
            <FieldObtainServiceContent />
          </Col>
        </Row>
      </Form>
      <div className="btnWrap">
        <div className="btn cursor-pointer" onClick={handleCancel}>
          {t(CNEnum.close)}
        </div>
        <div className="btn submit cursor-pointer" onClick={handleSubmit}>
          {t(CNEnum.submit)}
        </div>
      </div>
    </Modal>
  );
}
